import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type ClientResponse = {
  user: {
    email?: string
  }
}

const getSaltoConnectionStatus = async (residentId: string): Promise<boolean> => {
  const clientRes = await authAPI.get<ClientResponse>(`/client/${residentId}`)
  const email = clientRes.data?.user?.email
  if (!email) return false

  const saltoRes = await authAPI.get<boolean>('/salto-space/isconnected', {
    params: { email },
  })
  return !!saltoRes.data
}

export const SALTO_CONNECTION_STATUS_QUERY_KEY = 'useGetSaltoConnectionStatus'

export const getSaltoConnectionStatusQueryKey = (residentId: string) => [
  SALTO_CONNECTION_STATUS_QUERY_KEY,
  { residentId },
]

export const useGetSaltoConnectionStatus = (residentId: string | null | undefined) => {
  return useQuery({
    enabled: !!residentId,
    gcTime: 0,
    queryFn: () => getSaltoConnectionStatus(residentId!),
    queryKey: getSaltoConnectionStatusQueryKey(residentId ?? ''),
  })
}
